import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: 'app-new-performance-response-summary',
  templateUrl: './new-performance-response-summary.component.html',
  styleUrls: ['./new-performance-response-summary.component.less'],
})
export class NewPerformanceResponseSummaryComponent {
  @Input() sortDirection: any;
  @Input() perResults: any;
  @Input() queueRes: any;
  @Output() sortColumn = new EventEmitter<string>();
  columnName: any;

  constructor() {}

  sortByColumn(columnName: string) {
    this.columnName = columnName;
    console.log(this.sortDirection);
    this.sortColumn.emit(columnName);
  }
}
